var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoZf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "146px",
    height: "39px",
    viewBox: "0 0 146 39",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L3.67825 0L3.67825 5.21962L0 5.21962L0 0Z",
    transform: "translate(0.5057102 0.3986667)",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L4.23118 0L4.23118 5.21901L0 5.21901L0 0Z",
    transform: "translate(0.1563429 0.3986667)",
    id: "path_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L3.38433 0L3.38433 5.21939L0 5.21939L0 0Z",
    transform: "translate(0.04366123 0.3986667)",
    id: "path_3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L4.23041 0L4.23041 5.21901L0 5.21901L0 0Z",
    transform: "translate(0.382249 0.3986667)",
    id: "path_4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L3.67824 0L3.67824 5.21962L0 5.21962L0 0Z",
    transform: "translate(0.5477428 0.3986667)",
    id: "path_5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L4.55714 0L4.55714 7.49168L0 7.49168L0 0Z",
    transform: "translate(0.02935714 0.50832)",
    id: "path_6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1 0L1 36.3993L0 36.3993L0 0Z",
    transform: "translate(0.6618 0.4008333)",
    id: "path_7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_4"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_5"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_6"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_7"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-ZF",
    transform: "translate(0.2832031 0.2832031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(69 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.07759 11.8596L2.12645 11.8596C2.87327 12.614 3.74959 13.031 4.56155 13.031C6.55849 13.031 8.42514 11.2501 8.42514 8.15273C8.42514 5.40807 7.07731 3.5949 4.83763 3.5949C3.94502 3.5949 3.03535 4.02807 2.3211 4.66977L2.36996 3.22537L2.36996 0L0 0L0 12.8064L1.86665 12.8064L2.07759 11.8596ZM4.17224 5.53687C5.42237 5.53687 5.97375 6.4837 5.97375 8.20027C5.97375 10.1583 5.12922 11.0891 4.02567 11.0891C3.53865 11.0891 2.93841 10.9127 2.36996 10.4152L2.36996 6.4676C3.00278 5.84123 3.55494 5.53687 4.17224 5.53687Z",
    transform: "translate(0.4926041 9.786424)",
    id: "Fill-1",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22694 3.45C1.57429 3.83487 0 4.8461 0 6.77197C0 8.29687 1.07176 9.43613 2.6949 9.43613C3.73331 9.43613 4.64298 8.92247 5.43788 8.24857L5.48673 8.24857L5.66588 9.2115L7.61318 9.2115L7.61318 3.96367C7.61318 1.3639 6.4282 0 4.12339 0C2.6949 0 1.39592 0.529 0.324939 1.18757L1.18498 2.7439C2.02951 2.26243 2.84069 1.89367 3.68522 1.89367C4.80506 1.89367 5.19437 2.56757 5.22694 3.45ZM5.22694 4.8944L5.22694 6.70757C4.65927 7.26953 4.15596 7.59077 3.47351 7.59077C2.77633 7.59077 2.27302 7.28563 2.27302 6.57953C2.27302 5.77683 3.01906 5.18343 5.22694 4.8944Z",
    transform: "translate(10.06434 13.38155)",
    id: "Fill-3",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.224633L1.94808 0.224633L2.11016 1.81317L2.17531 1.81317C2.84069 0.6417 3.81473 0 4.7562 0C5.25951 0 5.55188 0.0805 5.82796 0.192433L5.40608 2.231C5.09743 2.1344 4.83763 2.0861 4.46384 2.0861C3.74959 2.0861 2.88955 2.55147 2.36996 3.85173L2.36996 9.2115L0 9.2115L0 0.224633Z",
    transform: "translate(19.78536 13.38125)",
    id: "Fill-5",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.73417C0 1.73343 2.17531 0 4.64298 0C5.76282 0 6.62286 0.433167 7.28902 0.995133L6.15212 2.51927C5.69767 2.1344 5.2758 1.92587 4.7562 1.92587C3.37657 1.92587 2.4351 3.03293 2.4351 4.73417C2.4351 6.4193 3.37657 7.51027 4.69106 7.51027C5.34094 7.51027 5.95747 7.2059 6.46078 6.78807L7.40224 8.34517C6.5422 9.09957 5.43788 9.43613 4.43204 9.43613C1.91551 9.43613 0 7.70347 0 4.73417",
    transform: "translate(25.90615 13.38125)",
    id: "Fill-7",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23661 0C2.06131 0 0 1.81317 0 4.73417C0 7.6866 1.98065 9.43613 4.51269 9.43613C5.64882 9.43613 6.80122 9.05127 7.69461 8.441L6.88265 6.9966C6.23355 7.39833 5.58445 7.62297 4.83763 7.62297C3.4898 7.62297 2.51575 6.85247 2.3211 5.37587L7.92184 5.37587C7.9862 5.16733 8.03506 4.73417 8.03506 4.301C8.03506 1.81317 6.73686 0 4.23661 0ZM4.26918 1.82927C5.43788 1.82927 5.99004 2.59977 5.99004 3.81953L2.28853 3.81953C2.4669 2.50317 3.31143 1.82927 4.26918 1.82927Z",
    transform: "translate(33.88879 13.38125)",
    id: "Fill-9",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.2871L0 0L2.36996 0L2.36996 10.3998C2.36996 10.9288 2.62976 11.1059 2.85698 11.1059C2.95392 11.1059 3.01906 11.1059 3.18192 11.0737L3.47351 12.8225C3.19743 12.9352 2.79184 13.0318 2.23967 13.0318C0.583959 13.0318 0 11.9562 0 10.2871",
    transform: "translate(43.58569 9.786117)",
    id: "Fill-11",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3669 0C2.09388 0 0 1.73343 0 4.73417C0 7.70347 2.09388 9.43613 4.3669 9.43613C6.63914 9.43613 8.7338 7.70347 8.7338 4.73417C8.7338 1.73343 6.63914 0 4.3669 0ZM4.3669 1.92587C5.60073 1.92587 6.29869 3.03293 6.29869 4.73417C6.29869 6.4193 5.60073 7.51027 4.3669 7.51027C3.13306 7.51027 2.4351 6.4193 2.4351 4.73417C2.4351 3.03293 3.13306 1.92587 4.3669 1.92587Z",
    transform: "translate(47.70977 13.38125)",
    id: "Fill-13",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.224633L1.94808 0.224633L2.11016 1.4122L2.17531 1.4122C2.97098 0.6417 3.89616 0 5.13 0C7.09359 0 7.93813 1.3478 7.93813 3.611L7.93813 9.2115L5.55188 9.2115L5.55188 3.90003C5.55188 2.51927 5.16257 2.02247 4.26919 2.02247C3.52237 2.02247 3.05163 2.37513 2.36996 3.03293L2.36996 9.2115L0 9.2115L0 0.224633Z",
    transform: "translate(58.1272 13.38125)",
    id: "Fill-15",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22694 3.45C1.57506 3.83487 0 4.8461 0 6.77197C0 8.29687 1.07176 9.43613 2.6949 9.43613C3.73331 9.43613 4.64298 8.92247 5.43788 8.24857L5.48673 8.24857L5.6651 9.2115L7.61318 9.2115L7.61318 3.96367C7.61318 1.3639 6.4282 0 4.12339 0C2.6949 0 1.39592 0.529 0.324939 1.18757L1.18498 2.7439C2.02951 2.26243 2.84069 1.89367 3.68522 1.89367C4.80506 1.89367 5.19437 2.56757 5.22694 3.45ZM5.22694 4.8944L5.22694 6.70757C4.65927 7.26953 4.15596 7.59077 3.47429 7.59077C2.77633 7.59077 2.27302 7.28563 2.27302 6.57953C2.27302 5.77683 3.01906 5.18343 5.22694 4.8944Z",
    transform: "translate(67.69242 13.38155)",
    id: "Fill-17",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L3.67825 0L3.67825 5.21962L0 5.21962L0 0Z",
    transform: "translate(0.5057102 0.3986667)",
    id: "Clip-20",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.60667C0 0.9959 0.901918 0 2.19547 0C2.79727 0 3.26567 0.290567 3.53865 0.608733L3.30057 0.8786C3.02837 0.574233 2.66465 0.374133 2.19547 0.374133C1.11906 0.374133 0.44049 1.23127 0.44049 2.59287C0.44049 3.96827 1.1051 4.84687 2.17453 4.84687C2.69257 4.84687 3.07722 4.6322 3.44094 4.23813L3.67825 4.5011C3.28661 4.95037 2.81122 5.22023 2.15359 5.22023C0.894939 5.22023 0 4.21743 0 2.60667",
    transform: "translate(0.5057102 0.3980533)",
    id: "Fill-19",
    fill: "#FFFFFF",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(5.428571 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L4.23118 0L4.23118 5.21901L0 5.21901L0 0Z",
    transform: "translate(0.1563429 0.3986667)",
    id: "Clip-23",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.11171 0C0.88098 0 0 0.9959 0 2.59287C0 4.19673 0.88098 5.21947 2.11171 5.21947C3.35641 5.21947 4.23118 4.19673 4.23118 2.59287C4.23118 0.9959 3.35641 0 2.11171 0ZM2.11171 0.373367C3.12608 0.373367 3.7969 1.22437 3.7969 2.59287C3.7969 3.96137 3.12608 4.84687 2.11171 4.84687C1.1051 4.84687 0.44049 3.96137 0.44049 2.59287C0.44049 1.22437 1.1051 0.373367 2.11171 0.373367Z",
    transform: "translate(0.1563429 0.3982067)",
    id: "Fill-22",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0.43351 0L2.51731 3.4638L3.0842 4.47963L3.11833 4.47963C3.09041 3.98207 3.06327 3.4776 3.06327 2.98693L3.06327 0L3.46188 0L3.46188 5.04007L3.02759 5.04007L0.950776 1.56937L0.377674 0.559667L0.342776 0.559667C0.363714 1.0442 0.398612 1.51417 0.398612 2.01863L0.398612 5.04007L0 5.04007L0 0Z",
    transform: "translate(11.79776 0.4883667)",
    id: "Fill-25",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(17.06122 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L3.38433 0L3.38433 5.21939L0 5.21939L0 0Z",
    transform: "translate(0.04366123 0.3986667)",
    id: "Clip-28",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.46583L0.258245 4.17527C0.628939 4.59003 1.15396 4.8461 1.73404 4.8461C2.48939 4.8461 2.9578 4.45203 2.9578 3.87857C2.9578 3.26983 2.55918 3.07663 2.05588 2.85507L1.29355 2.5231C0.839102 2.323 0.258245 2.00483 0.258245 1.265C0.258245 0.518267 0.901918 0 1.76894 0C2.38392 0 2.888 0.2622 3.20984 0.607967L2.97176 0.877833C2.67086 0.573467 2.27302 0.373367 1.76894 0.373367C1.11906 0.373367 0.684776 0.712233 0.684776 1.2305C0.684776 1.80397 1.18188 2.01863 1.55257 2.17733L2.3149 2.5093C2.89498 2.76537 3.38433 3.08353 3.38433 3.85097C3.38433 4.6253 2.73445 5.21947 1.73404 5.21947C0.992653 5.21947 0.405592 4.9151 0 4.46583",
    transform: "translate(0.04366123 0.39859)",
    id: "Fill-27",
    fill: "#FFFFFF",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(21.71428 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L4.23041 0L4.23041 5.21901L0 5.21901L0 0Z",
    transform: "translate(0.382249 0.3986667)",
    id: "Clip-31",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.11171 0C0.88098 0 0 0.9959 0 2.59287C0 4.19673 0.88098 5.21947 2.11171 5.21947C3.35641 5.21947 4.23041 4.19673 4.23041 2.59287C4.23041 0.9959 3.35641 0 2.11171 0ZM2.11171 0.373367C3.12608 0.373367 3.7969 1.22437 3.7969 2.59287C3.7969 3.96137 3.12608 4.84687 2.11171 4.84687C1.1051 4.84687 0.44049 3.96137 0.44049 2.59287C0.44049 1.22437 1.1051 0.373367 2.11171 0.373367Z",
    transform: "translate(0.382249 0.3982067)",
    id: "Fill-30",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1.46184 2.76537L2.8182 5.04007L3.29359 5.04007L1.91629 2.73087C2.69257 2.61357 3.1889 2.1505 3.1889 1.34857C3.1889 0.366467 2.50335 0 1.48976 0L0 0L0 5.04007L0.419551 5.04007L0.419551 2.76537L1.46184 2.76537ZM1.39204 2.4196L0.419551 2.4196L0.419551 0.345767L1.39204 0.345767C2.27302 0.345767 2.76237 0.615633 2.76237 1.34857C2.76237 2.0746 2.27302 2.4196 1.39204 2.4196Z",
    transform: "translate(28.30891 0.4881367)",
    id: "Fill-33",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(32.57143 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L3.67824 0L3.67824 5.21962L0 5.21962L0 0Z",
    transform: "translate(0.5477428 0.3986667)",
    id: "Clip-36",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.60667C0 0.9959 0.901918 0 2.19547 0C2.79727 0 3.26567 0.290567 3.53788 0.608733L3.30057 0.8786C3.02759 0.574233 2.66388 0.374133 2.19547 0.374133C1.11829 0.374133 0.44049 1.23127 0.44049 2.59287C0.44049 3.96827 1.10433 4.84687 2.17453 4.84687C2.6918 4.84687 3.07645 4.6322 3.44016 4.23813L3.67824 4.5011C3.28661 4.95037 2.81122 5.22023 2.15359 5.22023C0.894939 5.22023 0 4.21743 0 2.60667",
    transform: "translate(0.5477428 0.3980533)",
    id: "Fill-35",
    fill: "#FFFFFF",
    stroke: "none"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0.229 5L0.771 5L0.771 0L0.229 0L0.229 5Z",
    transform: "translate(107 1)",
    id: "Fill-39",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 1.22057L3.58849 1.22057L3.05146 1.64038L0 5.78021L0 7L5 7L5 5.78021L1.40269 5.78021L1.9285 5.40082L5 1.22057L5 0L0 0Z",
    transform: "translate(69 30)",
    id: "Fill-40",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.777487 0.908916C0.259162 1.51436 0 2.37843 0 3.50037C0 4.02584 0.0604712 4.50347 0.182199 4.93251C0.303141 5.36231 0.486911 5.73081 0.731937 6.03876C0.977749 6.34597 1.28953 6.58292 1.66649 6.75035C2.04346 6.91628 2.48796 7 3 7C3.95654 7 4.69555 6.69653 5.2178 6.09108C5.73927 5.48564 6 4.62157 6 3.50037C6 2.97491 5.93953 2.49728 5.8178 2.06749C5.69764 1.63844 5.5123 1.26919 5.26335 0.961986C5.01361 0.654778 4.70105 0.417085 4.3233 0.2504C3.94634 0.083716 3.50497 0 3 0C2.03717 0 1.2966 0.30347 0.777487 0.908916ZM1.54555 4.43769C1.48508 4.15216 1.45445 3.83972 1.45445 3.50037C1.45445 2.69909 1.58953 2.11084 1.8589 1.73561C2.12749 1.36113 2.50838 1.17352 3 1.17352C3.28272 1.17352 3.52147 1.23257 3.7178 1.35141C3.91257 1.47026 4.0712 1.63545 4.19215 1.84624C4.31309 2.05852 4.40262 2.30518 4.45995 2.58697C4.51728 2.86877 4.54555 3.17373 4.54555 3.50037C4.54555 4.32109 4.41047 4.91383 4.14189 5.27859C3.87251 5.6441 3.49162 5.82648 3 5.82648C2.73063 5.82648 2.49817 5.76968 2.30262 5.65382C2.10785 5.53871 1.94764 5.378 1.82356 5.1732C1.69869 4.96839 1.60602 4.72323 1.54555 4.43769Z",
    transform: "translate(76 30)",
    id: "Fill-41",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 6.99845L1.21019 6.99845L1.21019 3.34962L1.06036 2.25069L1.10741 2.25069L1.61914 3.34962L4.0359 7L5 7L5 0.000777174L3.78836 0.000777174L3.78836 3.67992L3.93819 4.75008L3.89114 4.75008L3.39751 3.67992L0.962652 0L0 0Z",
    transform: "translate(85 30)",
    id: "Fill-43",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7L2.48188 0L3.51812 0L6 7L4.57132 7L4.01619 5.45075L1.88358 5.45075L1.35852 7L0 7ZM2.94449 1.69073L2.73631 2.80078L2.23053 4.35003L3.71858 4.35003L3.20355 2.79067L2.9946 1.69073L2.94449 1.69073Z",
    transform: "translate(92 30)",
    id: "Fill-44",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 7L1.32085 7L1.32085 4.17015L3.78723 4.17015L3.78723 2.95036L1.32085 2.95036L1.32085 1.22057L4 1.22057L4 0L0 0Z",
    transform: "translate(103 30)",
    id: "Fill-45",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.469997 0.0935173Q0.218371 0.128011 0 0.167105L0 7L1.3021 7L1.3021 4.17072L1.9864 4.29873L3.49837 7L5 7L3.47916 4.36695L3.0136 4.06187C3.43778 3.92389 3.77697 3.67707 4.03045 3.32293C4.28318 2.96726 4.41029 2.50734 4.41029 1.9424C4.41029 1.56143 4.33934 1.24409 4.19672 0.990364C4.05409 0.738173 3.86343 0.538874 3.62622 0.393999C3.389 0.24989 3.11927 0.147941 2.8185 0.0889181C2.517 0.0291283 2.21106 0 1.90068 0Q1.70115 4.65661e-10 1.46394 0.00919842Q1.22561 0.0195467 0.973988 0.0390933C0.806237 0.0528909 0.638487 0.0705212 0.469997 0.0935173ZM1.60213 1.21266C1.73145 1.20576 1.86299 1.20269 1.99601 1.20269C2.33816 1.20269 2.59829 1.28625 2.77564 1.45412C2.953 1.62199 3.04168 1.85348 3.04168 2.14936C3.04168 2.54336 2.93379 2.82622 2.71874 2.99715C2.50296 3.16809 2.21475 3.25394 1.85338 3.25394L1.3021 3.25394L1.3021 1.25175C1.37156 1.23259 1.47207 1.21956 1.60213 1.21266Z",
    transform: "translate(110 30)",
    id: "Fill-46",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7L2.48143 0L3.5178 0L6 7L4.57113 7L4.01594 5.45109L1.88382 5.45109L1.35792 7L0 7ZM2.94487 1.69191L2.73589 2.80093L2.23005 4.35062L3.71906 4.35062L3.20319 2.79161L2.99422 1.69191L2.94487 1.69191Z",
    transform: "translate(117 30)",
    id: "Fill-48",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 6.99767L1.21019 6.99767L1.21019 3.34925L1.06109 2.25044L1.10741 2.25044L1.61986 3.34925L4.03662 7L5 7L5 0.000777087L3.78836 0.000777087L3.78836 3.67951L3.93819 4.74956L3.89186 4.74956L3.39751 3.67951L0.963376 0L0 0Z",
    transform: "translate(125 30)",
    id: "Fill-49",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-52",
    transform: "translate(132 30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L4.55714 0L4.55714 7.49168L0 7.49168L0 0Z",
    transform: "translate(0.02935714 0.50832)",
    id: "Clip-51",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.55714 7.0528C4.36143 7.2088 4.11143 7.3216 3.80857 7.3896C3.505 7.4576 3.19429 7.492 2.87571 7.492C2.49 7.492 2.12429 7.4248 1.77786 7.2904C1.43214 7.1576 1.12714 6.9408 0.864286 6.6424C0.6 6.3448 0.390714 5.9568 0.234286 5.48C0.0785714 5.0024 0 4.4248 0 3.7464C0 3.0392 0.0871429 2.448 0.262143 1.9712C0.436429 1.4944 0.662857 1.1104 0.941429 0.8184C1.22071 0.5272 1.53071 0.3176 1.87429 0.1904C2.21714 0.064 2.56 0 2.90357 0C3.27071 0 3.58143 0.028 3.83571 0.0824C4.09 0.1376 4.3 0.2024 4.46571 0.2784L4.21714 1.472C4.07643 1.396 3.91 1.3416 3.71643 1.3072C3.52357 1.2728 3.28929 1.256 3.01357 1.256C2.505 1.256 2.09643 1.4584 1.78714 1.864C1.47786 2.2696 1.32286 2.8984 1.32286 3.7512C1.32286 4.1224 1.36 4.4608 1.43357 4.7664C1.50714 5.0728 1.61857 5.3336 1.76857 5.5504C1.91857 5.7672 2.105 5.936 2.32929 6.056C2.55286 6.176 2.81143 6.236 3.10571 6.236C3.38143 6.236 3.61357 6.2056 3.80429 6.1432C3.99357 6.0816 4.15857 6.0024 4.3 5.9064L4.55714 7.0528Z",
    transform: "translate(0.02935714 0.50832)",
    id: "Fill-50",
    fill: "#FFFFFF",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 7L2.48111 0L3.51812 0L6 7L4.57209 7L4.01696 5.45109L1.88435 5.45109L1.35929 7L0 7ZM2.94526 1.69191L2.73709 2.80093L2.2313 4.35062L3.71858 4.35062L3.20355 2.79161L2.99537 1.69191L2.94526 1.69191Z",
    transform: "translate(138 30)",
    id: "Fill-53",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-56",
    transform: "translate(60 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1 0L1 36.3993L0 36.3993L0 0Z",
    transform: "translate(0.6618 0.4008333)",
    id: "Clip-55",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0L0.5 36.3995",
    transform: "translate(0.6618 0.4006021)",
    id: "Stroke-54",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.566
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 37L4.35654 37L4.35654 3.95025L20 3.95025L20 0L0 0Z",
    transform: "translate(33 1)",
    id: "Fill-57",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6L12 6L12 0L0 0L0 6Z",
    transform: "translate(40 16)",
    id: "Fill-58",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.61962 0L1.61962 6.15061L16.9246 6.15061L0 32.5503L0 37L26 37L26 30.8008L8.92866 30.8008L25.8041 4.40034L25.8041 0L1.61962 0Z",
    transform: "translate(0 1)",
    id: "Fill-59",
    fill: "#FFFFFF",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoZf);
export default __webpack_public_path__ + "static/media/logo-zf.b4b7465665fafc4bed81bb88b83e574f.svg";
export { ForwardRef as ReactComponent };